declare namespace $ {

	type $mol_view__sub_bog_ui_app_overview_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_badge__label_bog_ui_app_overview_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_overview_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $bog_ui_badge__label_bog_ui_app_overview_4 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_overview_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $bog_ui_badge__label_bog_ui_app_overview_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['label'] >
	>
	type $bog_ui_badge__type_bog_ui_app_overview_7 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_badge['type'] >
	>
	type $mol_view__sub_bog_ui_app_overview_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_9 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_12 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_badge'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_13 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Badge_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_17 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_18 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_19 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_empty'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_20 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Empty_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_22 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_23 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_24 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_25 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_skeleton'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_26 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Skeleton_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_33 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_34 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_35 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_36 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_breadcrumb'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_37 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Breadcrumb_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_41 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_42 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_43 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_44 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_sidebar'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_45 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Sidebar_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_48 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_49 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_50 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_51 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_52 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_sheet'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_53 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Sheet_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_57 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_58 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_59 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_60 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_toast'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_61 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Toast_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_62 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_64 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_65 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_66 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_67 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_command'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_68 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Command_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_69 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_71 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_app_overview_card__card_id_bog_ui_app_overview_73 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_id'] >
	>
	type $bog_ui_app_overview_card__card_title_bog_ui_app_overview_74 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_title'] >
	>
	type $bog_ui_app_overview_card__card_description_bog_ui_app_overview_75 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_app_overview_card['card_description'] >
	>
	type $bog_ui_app_overview_card__click_bog_ui_app_overview_76 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['go_table'] >
		,
		ReturnType< $bog_ui_app_overview_card['click'] >
	>
	type $bog_ui_app_overview_card__Preview_bog_ui_app_overview_77 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['Table_preview'] >
		,
		ReturnType< $bog_ui_app_overview_card['Preview'] >
	>
	type $mol_view__sub_bog_ui_app_overview_78 = $mol_type_enforce<
		ReturnType< $bog_ui_app_overview['cards'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_overview extends $mol_page {
		description( ): string
		Description( ): $mol_view
		go_badge( next?: any ): any
		Badge_s( ): $bog_ui_badge
		Badge_e( ): $bog_ui_badge
		Badge_i( ): $bog_ui_badge
		Badge_preview( ): $mol_view
		Card_badge( ): $bog_ui_app_overview_card
		go_empty( next?: any ): any
		Empty_icon( ): $mol_icon_magnify
		Empty_text( ): $mol_view
		Empty_preview( ): $mol_view
		Card_empty( ): $bog_ui_app_overview_card
		go_skeleton( next?: any ): any
		Skel_1( ): $bog_ui_skeleton
		Skel_2( ): $bog_ui_skeleton
		Skel_3( ): $bog_ui_skeleton
		Skeleton_preview( ): $mol_view
		Card_skeleton( ): $bog_ui_app_overview_card
		go_breadcrumb( next?: any ): any
		Bc_home( ): $mol_view
		Bc_sep( ): $mol_view
		Bc_cat( ): $mol_view
		Bc_sep2( ): $mol_view
		Bc_cur( ): $mol_view
		Breadcrumb_preview( ): $mol_view
		Card_breadcrumb( ): $bog_ui_app_overview_card
		go_sidebar( next?: any ): any
		Sb_i1( ): $mol_icon_home
		Sb_i2( ): $mol_icon_account
		Sb_i3( ): $mol_icon_cog
		Sb_bar( ): $mol_view
		Sb_content( ): $mol_view
		Sidebar_preview( ): $mol_view
		Card_sidebar( ): $bog_ui_app_overview_card
		go_sheet( next?: any ): any
		Sheet_panel( ): $mol_view
		Sheet_box( ): $mol_view
		Sheet_preview( ): $mol_view
		Card_sheet( ): $bog_ui_app_overview_card
		go_toast( next?: any ): any
		Toast_info_icon( ): $mol_icon_information
		Toast_info_mini( ): $mol_view
		Toast_ok_icon( ): $mol_icon_check_circle
		Toast_ok_mini( ): $mol_view
		Toast_preview( ): $mol_view
		Card_toast( ): $bog_ui_app_overview_card
		go_command( next?: any ): any
		Cmd_icon( ): $mol_icon_magnify
		Cmd_search( ): $mol_view
		Command_preview( ): $mol_view
		Card_command( ): $bog_ui_app_overview_card
		go_table( next?: any ): any
		Tbl_head( ): $mol_view
		Tbl_row1( ): $mol_view
		Tbl_row2( ): $mol_view
		Table_preview( ): $mol_view
		Card_table( ): $bog_ui_app_overview_card
		cards( ): readonly(any)[]
		Grid( ): $mol_view
		title( ): string
		body( ): readonly(any)[]
	}
	
	type $mol_view__sub_bog_ui_app_overview_card_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_overview_card_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_ui_app_overview_card extends $mol_button_minor {
		Title( ): $mol_view
		Card_desc( ): $mol_view
		card_id( ): string
		card_title( ): string
		card_description( ): string
		Preview( ): $mol_view
		attr( ): ({ 
			'bog_ui_app_overview_card': boolean,
		})  & ReturnType< $mol_button_minor['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=overview.view.tree.d.ts.map